import { render } from "./RegistrationPanel.vue?vue&type=template&id=02c42589&scoped=true"
import script from "./RegistrationPanel.vue?vue&type=script&lang=ts"
export * from "./RegistrationPanel.vue?vue&type=script&lang=ts"

import "./RegistrationPanel.vue?vue&type=style&index=0&id=02c42589&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02c42589"

export default script